import {
  ElementNode,
  type EditorConfig,
  type LexicalNode,
  type SerializedElementNode,
  type DOMConversionMap,
  type DOMConversionOutput,
  type DOMExportOutput,
  type LexicalEditor,
  type Spread,
} from 'lexical';

export type SerializedExpandableQuoteNode = Spread<
  { type: 'expandable-blockquote'; version: 1 },
  SerializedElementNode
>;

export class ExpandableQuoteNode extends ElementNode {
  static getType(): string {
    return 'expandable-blockquote';
  }

  static clone(node: ExpandableQuoteNode): ExpandableQuoteNode {
    return new ExpandableQuoteNode(node.__key);
  }

  createDOM(config: EditorConfig): HTMLElement {
    const blockquote = document.createElement('blockquote');
    blockquote.className =
      (config.theme.expandableQuote as string | undefined) ?? 'tg-expandable-quote';
    blockquote.setAttribute('data-expandable', 'true');
    return blockquote;
  }

  updateDOM(_prevNode: ExpandableQuoteNode, _dom: HTMLElement): boolean {
    return false;
  }

  exportJSON(): SerializedExpandableQuoteNode {
    return {
      ...super.exportJSON(),
      type: 'expandable-blockquote',
      version: 1,
    };
  }

  static importJSON(
    _serializedNode: SerializedExpandableQuoteNode
  ): ExpandableQuoteNode {
    return $createExpandableQuoteNode();
  }

  exportDOM(_editor: LexicalEditor): DOMExportOutput {
    const element = document.createElement('blockquote');
    element.setAttribute('expandable', '');
    return { element };
  }

  static importDOM(): DOMConversionMap | null {
    return {
      blockquote: (domNode: HTMLElement) => {
        if (domNode.hasAttribute('expandable')) {
          return {
            conversion: convertExpandableQuoteElement,
            priority: 2,
          };
        }
        return null;
      },
    };
  }

  isInline(): boolean {
    return false;
  }

  canBeEmpty(): boolean {
    return false;
  }

  canIndent(): boolean {
    return false;
  }
}

function convertExpandableQuoteElement(): DOMConversionOutput {
  return { node: $createExpandableQuoteNode() };
}

export function $createExpandableQuoteNode(): ExpandableQuoteNode {
  return new ExpandableQuoteNode();
}

export function $isExpandableQuoteNode(
  node: LexicalNode | null | undefined
): node is ExpandableQuoteNode {
  return node instanceof ExpandableQuoteNode;
}
